import { DetailOrderDTO } from '../dtoTypes'
import { DetailOrder } from '../types'
import { adaptOrderDTO } from './adaptOrderDTO'
import { adaptBookingDTO } from './adaptBookingDTO'
import { adaptPaymentDTO } from 'entities/payments/model/adapters/adaptPaymentDTO'

export const adaptDetailOrderDTO = ({
    bookings,
    ...order
}: DetailOrderDTO): DetailOrder => ({
    ...adaptOrderDTO(order),
    bookings: bookings?.map(adaptBookingDTO) ?? [],
    createdAt: new Date(order.created_at),
    payments: order.payments?.map(adaptPaymentDTO) ?? []
})
